import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'
import FloatingNavbar from '../FloatingNavbar'

const Iphone16Pro = () => {
    return (
        <div>
            <Navbar />
            <FloatingNavbar />
            Iphone16Pro
            <Footer />
        </div>
    )
}

export default Iphone16Pro
